import React from 'react';
import { find, isEmpty, isNil, join, reduce, slice, some } from 'lodash';
import translateService from '../../../common/translateService.js';

import './ProductSelectionHint.scss';

const ProductSelectionHint = ({ selectionAttributes, productAttributes }) => {
    const formatAttributes = (attr) => {
        let s = reduce(
            attr,
            (prev, currVal, currKey) => {
                const attribute = find(
                    productAttributes,
                    (p) => p.fieldId === currKey
                );
                return (prev += isNil(currVal)
                    ? !isNil(attribute)
                        ? `${attribute.name}, `
                        : ''
                    : '');
            },
            ''
        );

        if (!isEmpty(s)) {
            s = join(slice(s, 0, s.length - 2), '');
        }

        return s;
    };

    const formattedAttributes =
        isNil(selectionAttributes) ||
        isEmpty(selectionAttributes) ||
        !some(selectionAttributes, (v) => isNil(v))
            ? ''
            : formatAttributes(selectionAttributes);

    return (
        <div className='prd-selectionHint'>
            <p
                dangerouslySetInnerHTML={{
                    __html: translateService.interpolate(
                        `productDetail.selectionHint`,
                        {
                            attr: formattedAttributes,
                        }
                    ),
                }}
            />
        </div>
    );
};

export default ProductSelectionHint;
